import { Auth } from 'shared/services'

export const useAuth = () => ({ isAuthenticated: Auth.isAuthenticated() })
